// @ts-check
import isString from 'lodash/isString';

/**
 * @param {string} url
 */
function isValidWebsiteUrl(url) {
  if (!isString(url)) {
    return false;
  }
  return url.startsWith('http://') || url.startsWith('https://');
}

export default isValidWebsiteUrl;
